export default __webpack_public_path__ + "static/media/card4.33f7ec00.svg";